import CategoriesNav from "./categories-nav";

export default CategoriesNav